{
    "watchForFileChanges" : false,
    "baseUrl" : "https://test-web.inbooma.net",
    "localApiUrl": "https://test-api.inbooma.net/api",
    "viewportWidth": 1100,
    "viewportHeight": 700,
    "video": false
}
